// Notifications settings section — coming soon placeholder with outbox status badge.
import { createFileRoute } from "@tanstack/react-router";
import { useScrollToAnchor } from "@/features/settings/hooks/use-scroll-to-anchor";
import { NotificationsEmptyState } from "@/features/settings/notifications/components/NotificationsEmptyState";

function NotificationsSection() {
  useScrollToAnchor();
  return <NotificationsEmptyState />;
}

export const Route = createFileRoute("/_admin/settings/notifications")({
  component: NotificationsSection,
});
